<div class="table-container">
  <table class="table">
    <thead>
      <tr>
        <th class="title-header">
          <p class="title-task">
            <span class="title-list">{{ "task.title" | translate }}</span>
          </p>
          <button class="plus" (click)="createTask()">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
        </th>
      </tr>
    </thead>

 

    <tbody>
      <tr *ngIf="showCreateForm">
        <td colspan="1">
          <div class="create-task-form">
            <task-details [currentTicket]="currentTicket"></task-details>
          </div>
        </td>
      </tr>
      <ng-container *ngFor="let task of tasks | async">
        <tr (click)="selectTask(task)" [class.selected]="task === selectedTask">
          <td>{{ task.title }}</td>
        </tr>

        <tr *ngIf="task === selectedTask" class="details-row">
          <td colspan="1">
            <div class="details-container">
              <task-details [currentTicket]="currentTicket"></task-details>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
